import React from 'react';
import navianceLogo from '../theme/images/naviance-logo.svg';
import navianceEmblem from '../theme/images/naviance-emblem.svg';
import navianceStudent from '../theme/images/naviance-student.svg';
import './styles.css';

class Header extends React.Component {
  render() {
    return (
      <header className="header">
        <nav className="nav" data-test-id="nav">
          <div className="navContainer">
            <a href="/" className="logoWrapper">
              <img className="emblem" data-test-id="family_connection_emblem" src={navianceEmblem} alt="Naviance Logo" />
              <img className={['logo', 'nophone'].join(' ')} data-test-id="family_connection_header" src={navianceLogo} alt="Naviance" />
              <span className={['logoDivider', 'notablet'].join(' ')}>|</span>
              <img
                className={['logo', 'notablet'].join(' ')}
                data-test-id="family_connection_logo"
                src={navianceStudent}
                alt="Naviance Student"
              />
            </a>
          </div>
        </nav>
      </header>
    );
  }
}

export default Header;
